import React, { useContext, useEffect, useState } from "react";
import ButtonGroup from "./ButtonGroup";
import { MapContext } from "./MapContext";
import { AppContext } from "./AppContext";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button, Menu, MenuItem } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default function ParticipateFilter() {
  const options = [
    { value: "all", label: "Show All" },
    { value: "Arts and Culture", label: "Arts and Culture" },
    { value: "Community", label: "Community" },
    { value: "Environment", label: "Environment" },
    { value: "Health and Wellbeing", label: "Health and Wellbeing" },
    { value: "Major Projects", label: "Major Projects" },
    { value: "Parks and Recreation", label: "Parks and Recreation" },
    {
      value: "Planning, Design and Renewal",
      label: "Planning, Design and Renewal"
    },
    { value: "Technology", label: "Technology" },
    { value: "Transport and Movement", label: "Transport and Movement" },
  ];


  const {setActiveFeature} = useContext(AppContext);
  const [selection, setSelection] = useState("all");
  const {
    mapRef: { current: map }
  } = useContext(MapContext);
  useEffect(() => {
    if (selection && map.setFilter) {
      map.setFilter(
        "participate-engagements",
        selection === "all"
          ? ["has", "Category"]
          : ["==", ["get", "Category"], selection]
      );
    }
    setActiveFeature()
    // eslint-disable-next-line
  }, [selection]);


  
const { breakpoints } = useTheme();
  const isLarge = useMediaQuery(breakpoints.up("md"));
  const props = {
    options,
    value: selection,
    onChange: s => setSelection(s.value)
  }

  return isLarge ? (
    <ButtonGroup
      {...props}
      compact={false}
      pop="#ADCCEB"
    />
  ) : <ButtonDropdown {...props} />;
}


function ButtonDropdown({options, value, onChange}){
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = e => setAnchorEl(e.currentTarget);
  const handleSelect = o => {
    setAnchorEl(null);
    onChange(o);
  }

  return <>
    <Button onClick={handleClick} variant="contained" color="secondary">{value}  <ExpandMoreIcon /></Button>
    <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClick={() => setAnchorEl(null)}>
      {options.map(o=> (
        <MenuItem key={o.value} onClick={() => handleSelect(o)}>{o.label}</MenuItem>
      ))}
    </Menu>
    </>
}